import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AppRoutes } from '../models/routes.model';
import { ErrorHandlerService } from '../services/error-handler.service';
import { SUPPRESS_HTTP_ERROR_TOAST } from '../utils/http/http-context.tokens';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorService = inject(ErrorHandlerService);
  const router = inject(Router);
  const suppressToast = req.context.get(SUPPRESS_HTTP_ERROR_TOAST);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      // I 401 ecommerce riguardano la sessione opaca interna, non Keycloak:
      // niente redirect alla pagina di login (li gestisce l'interceptor dedicato).
      if (err.status === 401 && !req.url.includes('/api/v1/ecommerce/')) {
        errorService.addHttpError(err.status, req.url, err, { showToast: !suppressToast });
        void router.navigate(
          [AppRoutes.ROOT, AppRoutes.AUTH, AppRoutes.AUTH_LOGIN],
          {
            queryParams: { returnUrl: router.url },
          }
        );

        return throwError(() => err);
      }

      if (err.status === 403) {
        errorService.addError('Non hai i permessi per questa operazione.', {
          severity: 'warning',
          source: 'http',
          statusCode: 403,
          showToast: !suppressToast,
        });
        return throwError(() => err);
      }

      errorService.addHttpError(
        err.status,
        req.url,
        err,
        { showToast: !suppressToast }
      );

      return throwError(() => err);
    })
  );
};
